import React from 'react';
import './CardSizeSelector.css';

export type CardSize = 'S' | 'M' | 'L';

interface CardSizeSelectorProps {
  value: CardSize;
  onChange: (size: CardSize) => void;
  /** Extra class on the options group (spacing/layout tweaks per consumer). */
  className?: string;
  /**
   * Stop click propagation on the buttons. Needed when the selector lives inside a
   * dropdown that closes on outside-click (e.g. the profile View menu).
   */
  stopPropagation?: boolean;
}

const SIZES: CardSize[] = ['S', 'M', 'L'];

/**
 * Controlled S / M / L card-size toggle. Presentational only — the owner holds the size
 * value and decides persistence (session-local on Trade Alerts, localStorage on profile).
 * Styling matches the original profile selector.
 */
export const CardSizeSelector: React.FC<CardSizeSelectorProps> = ({
  value,
  onChange,
  className,
  stopPropagation,
}) => (
  <div className={`card-size-selector ${className || ''}`} role="group" aria-label="Card size">
    {SIZES.map((size) => (
      <button
        key={size}
        type="button"
        className={`card-size-btn ${value === size ? 'active' : ''}`}
        aria-pressed={value === size}
        onClick={(e) => {
          if (stopPropagation) e.stopPropagation();
          onChange(size);
        }}
      >
        {size}
      </button>
    ))}
  </div>
);

export default CardSizeSelector;
